
import {useState,useEffect, useContext} from 'react';
import {AppState, AppContext} from '../context/AppProvider'

function VoteCard(props) {
    let vote = props.vote
const {
    currentVote,
    setCurrentVote,
        isLoggedIn,
        view, 
        setView,
        room,
        setRoom,
        user,
        setUser,
        meetings,
        setMeetings,
        currentMeeting,
        setCurrentMeeting,
        events,
        setEvents,
        currentEvent,
        setCurrentEvent,
        notifications,
        setNotifications,
        setIsLoading } = useContext(AppContext)

    const {_id,title,type,space,descr,options,voters,meeting_id,status,vote_time_handling,end}  = vote

    let status_class = `${status} status blink-faster`
    let time_class = `${vote_time_handling} blink-slower`
    const [showAdmin , setShowAdmin] = useState(false)
    const [showDuration , setShowDuration] = useState(false)
    // const launch_date = `2023-03-01T08:00:00Z`
    const [time, setTimer] = useState('')
   const [extVoteToggle , setExtVoteToggle] = useState(false)
    
  
    
    function timer(){
        
        var countDownDate = new Date(end).getTime();
        // Update the count down every 1 second
        var x = setInterval(function() {
        // Get today's date and time
        var now = new Date().getTime();
        // Find the distance between now and the count down date
        var distance = countDownDate - now;
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        // Display the result in the element with id="demo"
        setTimer(`${days}d ${hours}h ${minutes}m ${seconds}s`)
        // document.getElementById("demo").innerHTML = days + "d " + hours + "h "
        // + minutes + "m " + seconds + "s ";

        // If the count down is finished, write some text
        if (distance < 0) {
            clearInterval(x);
            // document.getElementById("demo").innerHTML = "EXPIRED";
            setTimer(`expired`)
        }
        }, 1000);
            }
    function voteClick(vote){
        setCurrentVote(vote)
        // window.localStorage.setItem('vote','')
        // window.localStorage.setItem('vote',JSON.stringify(vote))
        // if(props.view === 'meeting'){
        //     window.location.href = `/vote`
        // }else 
        
        // if((props.view === 'event' || ' meeting')){
            setExtVoteToggle(true)
            window.localStorage.setItem('voteToggle',extVoteToggle)
            console.log('Vote click:',JSON.parse(window.localStorage.getItem('voteToggle')))
        // }

    }   
      timer()
        return (
        <section id="vote-block">   
           
            <div className="vote-component .color-grad-blue" >
                {/* ========= [Heeader]  =========*/}
                <div className="vote-card-header">
                    <span className="vote-title"> 
                        <span id="vote-title"><b>"{title}"</b></span>
                    </span>
                    <div id="scroll-container">
                        <div id="scroll-text">
                            <h6>{descr}</h6>
                        </div>
                    </div>
                        <br/>
                </div>
                    {/* <h6>{orgnaization_name}</h6>
                    <span>
                       {!showAdmin&&(
                        <span id="admin-tag"  className='blink' 
                            onClick={() => setShowAdmin(true)}>
                            admin &#9663;
                        </span> )}
                        {showAdmin&&( <span className="admin_info blink"
                        onClick={() => setShowAdmin(false)}
                        >{meeting_admin}&#9667;</span>)} 
                    </span> */}
               
                {/* ========= [Top] =========*/}
                <div className="vote-comp-top">
                    <div className="vote-comp-top-left">
                       <span className={type}>{type}</span>
                    </div>
                <div>

            </div>
                    
                   <div className="vote-comp-top-right">
                        <span className={status_class}><span id="vote-status"> &#x2022; {status} </span></span>
                    </div>
                </div>

                {/* ========= [Bottom] =========*/}
                <div className="vote-comp-bottom">
                      {/* ========= [Bottom Left]  =========*/}
                   <div className="vote-comp-btm-left">
                        <span className = "meeting-attendees" id="meeting-attendees">
                            voters:
                             {voters?.length}
                        </span>
                    </div>
                      {/* ========= [Bottom Center] =========*/}
                      <div onClick={voteClick} className="vote-comp-btm-center color-grad-blue-text "
                      value ={vote} 
                      >
                        vote
                     </div>
                    {/* ========= [Bottom Right] =========*/}
                   <div className="meeting-comp-btm-right">  
                   <span>
                       {!showDuration&&(
                        <span className={time_class} id="time_handling" 
                            onClick={() => 
                            setShowDuration(true)}>
                            &#9663; {vote_time_handling}-time 
                        </span> )}
                        {showDuration&&( 
                            <span className= {time_class} id="time_handling"
                            onClick={() => setShowDuration(false)}
                            >&#9657; {time}</span>)} 
                    </span> 
                    </div>
                </div>

            </div>
        </section>
  );
}
export default VoteCard
